import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from "../grid.base.case";
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { WebParameterContext } from '../../../../model/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { CommonService } from '../../../../service/common.service';
import { BaseCase } from '../../../basecase';
declare var app;
@Component({
  selector: 'app-mz-grid-list-interimplan',
  templateUrl: './mz-grid-list-interimplan.component.html',
  styleUrls: ['./mz-grid-list-interimplan.component.scss']
})
export class MzGridListInterimplanComponent extends GridBaseCase {
  //dataArrayList: Array<any> = [];
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private platform: Platform,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase
  ) { super(); }
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  loadingchileData(data) {
    const that = this;
    //that.dataArrayList = data;
  }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.baseService.ListData.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber) {
    
    let that = this;
    console.log(that.PageNumber);
    if(localStorage.getItem("setMap")){
      return;
    }
    that.PageNumber = PageNumber;
   
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const date = localStorage.getItem('PlanMakingListDate');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (!that.com.GetAccount.IsAdmin) {
      // let obj = {"userId":that.com.GetAccount.Id};//获取当前登录者ID
      let storeSearch = {};
      if (that.baseService.storeSearch.searchType != 0) {
        for (let item in that.baseService.storeSearch) {
          if (that.baseService.storeSearch[item]) {
            storeSearch[item] = that.baseService.storeSearch[item]
          }
        }
      }
      if (that.baseService.storeSearch.searchType == 1) {//搜索
        storeSearch = {};
        storeSearch['ObjectType'] = that.baseService.storeSearch['ObjectType'];
        storeSearch['userId'] = that.baseService.storeSearch['userId'];
        if (storeSearch['ObjectType'] == 1 && that.baseService.storeSearch['Name']) {
          storeSearch['Name'] = that.baseService.storeSearch['Name'];
        } else if (storeSearch['ObjectType'] == 2 && that.baseService.storeSearch['Name']) {
          storeSearch['Code'] = that.baseService.storeSearch['Name'];
        }
      } else if (that.baseService.storeSearch.searchType == 2) {//筛选
        // delete storeSearch['ObjectType'];
        delete storeSearch['Name'];
        delete storeSearch['Code'];
        delete storeSearch['searchType'];
      } else if (that.baseService.storeSearch.searchType == 3) {//地图

      }
      if (!storeSearch['userId']) {
        storeSearch['userId'] = that.com.GetAccount.Id;
      }
      if (date) {
        storeSearch['date'] = date;
      }
      // let bodys = Object.assign(obj,storeSearch);
      body.RequestBody = JSON.stringify(storeSearch);
    }
    that.http.post(app.DEFAULTURL, body).then(data => {


      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.baseService.ListData = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          that.baseService.ListData.push(objfield);
          console.log(that.baseService.ListData);
          //console.log(that.dataArrayList);
        });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.baseService.ListData.length) {
          that.infiniteScroll.disabled = true;
        } else {
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  EventLink(ev, item) {
    // console.log(item);
    if (item.isCheck) {
      item.isCheck = false;
    } else {
      item.isCheck = true;
    }
    this.dataindex(this.baseService.ListData);
  }
  /**
   * 获取选中的数据源
   */
  dataindex(dataArray: Array<any>) {
    const that = this;
    let objarray: Array<any> = [];
    dataArray.forEach((items, index) => {
      if (items.isCheck) {
        objarray.push(items);
      }
    });
    that.baseService.arrayData = objarray;
  }


  DateFormat(dateFormat) {
    let date = dateFormat;
    if (date) {
      date = new Date(date.toString().replace(/-/g,"/"));
    } else {
      return;
    }
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    if (m < 10) {
      m = '0' + m;
    }
    let d = date.getDate();
    if (d < 10) {
      d = '0' + d;
    }
    return y + '-' + m + '-' + d;
  }
}
